<template>
    <div class="content">
        <table border="1" cellspacing="0">
            <colgroup>
                <col style="width:12%">
                <col style="width:16%">
                <col style="width:20%">
                <col style="width:20%">
                <col style="width:10%">
                <col style="width:22%">
            </colgroup>
            <tr>
                <td colspan="6" class="table-title"><b>个人信息收集清单</b></td>
            </tr>
            <tr>
                <td><b>信息类型</b></td>
                <td><b>信息名称</b></td>
                <td><b>使用目的</b></td>
                <td><b>收集场景</b></td>
                <td><b>收集情况</b></td>
                <td><b>信息内容</b></td>
            </tr>
            <tr>
                <td rowspan="6">用户基本信息</td>
                <td>手机号</td>
                <td>用于注册创建账号，完善网络身份标识</td>
                <td>用户首次注册时主动输入</td>
                <td>收集1条</td>
                <td>133****1234</td>
            </tr>
            <tr>
                <td>电子邮箱</td>
                <td>1.用于注册创建账号；2.修改已创建账号的密码；3.注销账号时收取验证信息；</td>
                <td>用户首次注册账户时，或使用修改密码、注销账户功能时主动输入</td>
                <td>收集1条</td>
                <td>Todo***@163.com</td>
            </tr>
            <tr>
                <td>Apple ID</td>
                <td>用于创建都都会员账号，完善网络身份标识</td>
                <td>用户首次登录时获取（仅限于用户已授权给苹果）</td>
                <td>收集1条</td>
                <td>Appleid23de**********</td>
            </tr>
            <tr>
                <td>昵称</td>
                <td>用于账号展示</td>
                <td>用户编辑信息自主输入</td>
                <td>收集1条</td>
                <td>都都</td>
            </tr>
            <tr>
                <td>出生年月</td>
                <td>用于创建使用者学习信息，对所选学习级别提供建议</td>
                <td>用户编辑信息自主输入</td>
                <td>收集1条</td>
                <td>2015-12</td>
            </tr>
            <tr>
                <td>收货地址</td>
                <td>用于营销活动邮寄相关产品</td>
                <td>用户获得营销活动赠品/奖品时通过小程序或客服主动提供</td>
                <td>收集1条</td>
                <td>张*，123****6789，北京市朝阳区**********</td>
            </tr>
            <tr>
                <td>设备信息</td>
                <td>硬件型号、操作系统类型、设备中的国家/地区、设备中的语言设置</td>
                <td>用于排查产品使用问题，保障产品的安全和使用体验</td>
                <td>使用APP过程中APP收集</td>
                <td>收集1条</td>
                <td>BOE C20、Android、11*****-****-****-****-****C9、CN、zh、</td>
            </tr>
            <tr>
                <td>使用信息</td>
                <td>应用使用数据、应用崩溃信息、</td>
                <td>改善产品的使用功能，提升产品的使用体验</td>
                <td>使用APP过程中APP收集</td>
                <td>收集1条</td>
                <td>累计使用天数 **天， 累计获得成果数量** 个</td>
            </tr>
        </table>
    </div>
</template>
<script>

export default {
  name: 'privacyCollection',
}
</script>
<style scoped>
    .content {
        padding: 30px;
        line-height: 2em;
        overflow-x: hidden;
    }
    table {
        width: 100%;
        max-width: 100%;
        table-layout: fixed;
        border-collapse: collapse;
    }
    td {
        padding: 6px;
        vertical-align: top;
        overflow-wrap: anywhere;
    }
    .table-title {
        text-align: center;
    }

    @media (max-width: 720px) {
        .content {
            padding: 10px;
            line-height: 1.5em;
            font-size: 12px;
        }
        td {
            padding: 3px;
        }
    }
</style>
